import TourPage from "@/components/TourPage";

export default function RwandaSafari10Day() {
  return (
    <TourPage
      tourId="rwanda/safari-10-day"
      title="10 Days Rwanda Safari"
      duration="10 Days / 9 Nights"
      price="Contact for price"
      image="/Visit-Rwanda.png"
      description="Experience the once-in-a-lifetime Rwanda adventure on this 10-day journey, featuring gorilla trekking, chimpanzee trekking, golden monkey trekking, game drives, boat cruises, and cultural experiences."
      itinerary={[
        {
          day: 1,
          title: "Arrival in Kigali City",
          description: "Begin your Rwanda adventure in the capital city.",
          activities: [
            "Arrive in Kigali and transfer to your hotel",
            "City tour, including genocide memorial grounds and local markets"
          ],
          accommodation: "Kigali Hotel",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Drive to Akagera National Park",
          description: "Start your wildlife adventure in Akagera National Park.",
          activities: [
            "Depart for Akagera National Park",
            "Game drive in the park"
          ],
          accommodation: "Akagera Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Game Drive and Afternoon Boat Cruise",
          description: "Full day exploring Akagera's diverse wildlife.",
          activities: [
            "Morning game drive",
            "Afternoon boat cruise on Lake Ihema"
          ],
          accommodation: "Akagera Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Transfer from Akagera National Park to Nyungwe Forest",
          description: "Journey to the pristine Nyungwe Forest.",
          activities: [
            "Depart for Nyungwe Forest National Park",
            "Transfer to your lodge"
          ],
          accommodation: "Nyungwe Forest Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Chimp Tracking and Afternoon Canopy Walk",
          description: "Experience the forest's primates and canopy.",
          activities: [
            "Chimpanzee trekking in Nyungwe Forest National Park",
            "Canopy walk in the afternoon"
          ],
          accommodation: "Nyungwe Forest Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Transfer to Volcanoes National Park and Visit Iby'iwacu Cultural Village",
          description: "Travel to the famous Volcanoes National Park.",
          activities: [
            "Depart for Volcanoes National Park",
            "Visit Iby'iwacu Cultural Village"
          ],
          accommodation: "Volcanoes Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 7,
          title: "Mountain Gorilla Trekking Experience",
          description: "The highlight of your Rwanda adventure.",
          activities: [
            "Gorilla trekking in Volcanoes National Park"
          ],
          accommodation: "Volcanoes Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 8,
          title: "Golden Monkey Trekking Adventure and Drive to Lake Kivu",
          description: "Trek for golden monkeys and visit Lake Kivu.",
          activities: [
            "Golden monkey trekking in Volcanoes National Park",
            "Drive to Lake Kivu"
          ],
          accommodation: "Lake Kivu Hotel",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 9,
          title: "Leisure Time on Lake Kivu",
          description: "Relax and enjoy Lake Kivu's beauty.",
          activities: [
            "Leisure time on Lake Kivu",
            "Boat cruise and fishing"
          ],
          accommodation: "Lake Kivu Hotel",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 10,
          title: "Drive Back to Kigali City and Departure",
          description: "Return to Kigali for your departure.",
          activities: [
            "Depart for Kigali",
            "Drop off at the airport for your departure flight"
          ],
          meals: "Breakfast"
        }
      ]}
      inclusions={[
        "Airport transfers",
        "Accommodation and meals",
        "Full-time fueled safari car",
        "Park entrance fees",
        "Bottled water throughout",
        "English/French speaking driver",
        "All activities mentioned in the itinerary"
      ]}
      exclusions={[
        "Flight fares",
        "Personal items and all activities not mentioned in the itinerary",
        "Visa fees",
        "Tip",
        "Alcoholic and non-alcoholic beverages"
      ]}
    />
  );
}